import React, { useState, useContext, useEffect, useRef } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar'; 
import ErrorBoundary from "../ErrorBoundary.js";
import Chatpanel from '../Chatbot/Chatpanel';
import { GlobalStateContext } from '../Context/GlobalStateProvider.js';
import UpgradePlansModal from '../AuthenticationPages/UpgradePlansModal'; // adjust path if your folder is different

const Layout = ({aiAvailable, searchQuery, handleSearchChange, setSearchQuery,filter,handleFilterChange }) => {
  const location = useLocation();
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [showUpgrade, setShowUpgrade] = useState(false);
  const { isBillingFullscreen } = useContext(GlobalStateContext);
  const licensePopupOpen = useRef(false);

  // One central handler: any API call blocked by the license filter shows the reason once
  useEffect(() => {
    const MySwal = withReactContent(Swal);

    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const data = error.response?.data;

        if (error.response?.status === 403 && data?.licenseBlocked && !licensePopupOpen.current) {
          licensePopupOpen.current = true; // dashboard fires several calls at once, show only one popup
          const role = sessionStorage.getItem("role");
          const isLimit = data.reason === "INVOICE_LIMIT" || data.reason === "SALES_LIMIT";

          MySwal.fire({
            icon: "warning",
            title: isLimit ? "Free Trial Ended" : "License Problem",
            text: data.message,
            confirmButtonText: role === "ADMIN" ? "Upgrade Plan" : "OK",
            showCancelButton: role === "ADMIN",
            allowOutsideClick: false,
          }).then((result) => {
            licensePopupOpen.current = false;
            if (result.isConfirmed && role === "ADMIN") {
              setShowUpgrade(true);
            }
          });
        }

        return Promise.reject(error); // pages still get the error, nothing is swallowed
      }
    );

    return () => axios.interceptors.response.eject(interceptorId);
  }, []);

  // Floating AI button style
  const aiBtnStyle = {
    position: 'fixed',
    bottom: '30px',
    right: '30px',
    zIndex: 1000,
    display: isChatOpen ? 'none' : 'flex',
    alignItems: 'center',
    background: 'linear-gradient(90deg, #4f8cff 0%, #6f6fff 100%)',
    color: '#fff',
    border: 'none',
    borderRadius: '50px',
    boxShadow: '0 4px 16px rgba(79,140,255,0.18)',
    padding: '10px 18px 10px 12px',
    fontWeight: 600,
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'background 0.2s',
    gap: '10px',
  };

  return (
    <div>
      {/* ── Sidebar — hidden in billing fullscreen mode ── */}
      <div style={{
        display: isBillingFullscreen ? 'none' : 'block',
        transition: 'all 0.2s ease',
      }}>
        <ErrorBoundary>
          <Sidebar
            filter={filter}
            handleFilterChange={handleFilterChange}
          />
        </ErrorBoundary>
      </div>

      {/* ── Header — hidden in billing fullscreen mode ── */}
      <div style={{
        display: isBillingFullscreen ? 'none' : 'block',
        transition: 'all 0.2s ease',
      }}>
        <ErrorBoundary>
          <Header 
            searchQuery={searchQuery}
            handleSearchChange={handleSearchChange}
            setSearchQuery={setSearchQuery}
          />
        </ErrorBoundary>
      </div>

      <div
        className="pcoded-main-container"
        style={isBillingFullscreen ? {
          marginLeft: 0,
          paddingTop: 0,
          transition: 'all 0.2s ease',
        } : { transition: 'all 0.2s ease' }}
      >
        <div className="pcoded-content">
          <ErrorBoundary>
            <Outlet key={location.pathname}/>
          </ErrorBoundary>
        </div>
      </div>

      {/* Upgrade plans popup (opened from the "Free Trial Ended" alert) */}
      <UpgradePlansModal show={showUpgrade} onClose={() => setShowUpgrade(false)} />

      {/* Floating AI Button */}
      {/* {aiAvailable && (<div>  <button
        style={aiBtnStyle}
        onClick={() => setIsChatOpen(true)}
        title="Ask AI"
        className="ai-float-btn"
      >
        <i className="fa fa-robot" style={{ fontSize: 22, marginRight: 8 }}></i>
        Ask AI
      </button>
      {isChatOpen && (
        <Chatpanel onClose={() => setIsChatOpen(false)} />
      )}</div>)} */} 
    </div>
  );
};

export default Layout;